import * as ApiFunctionCalls from '@/utils/ApiFunctionCalls';
import { translate } from '@/utils/translate';

const state = {
  tickets: null,
  ticketsFilters: {
    categories: [],
    contacts: [],
    complaintTypes: [],
    statuses: [],
    priorities: []
  },
  ticketsElementsData: null,
  ticketInfo: {},
  ticketFiles: [],
  TicketThreads: [],
  saveTicketResult: null
};

const getters = {
  ticketsGetter: state => state.tickets,
  ticketsFiltersGetter: state => state.ticketsFilters,
  ticketInfoGetter: state => state.ticketInfo,
  ticketsElementsDataGetter: state => state.ticketsElementsData,
  ticketFilesGetter: state => state.ticketFiles,
  TicketThreadsGetter: state => state.TicketThreads,
  saveTicketResultGetter: state => state.saveTicketResult
};

const actions = {
  async getTickets({ commit }, params) {
    try {
      let tickets = await ApiFunctionCalls.getTickets(params);
      commit('SET_TICKETS', tickets);

      let statusesAll = [translate('b2b_open'), translate('b2b_in_progress'), translate('b2b_resolved')];
      let prioritiesAll = [translate('b2b_High'), translate('b2b_Medium'), translate('b2b_Low')];
      /**
       * find filters
       */
      let categories = [{ id: '0', title: translate('b2b_all') }];
      let contacts = [{ id: '0', title: translate('b2b_all') }];
      let complaintTypes = [{ id: '0', title: translate('b2b_all') }];
      let statuses = [{ id: '0', title: translate('b2b_all') }];
      let priorities = [{ id: '0', title: translate('b2b_all') }];
      if (tickets.length) {
        for (let i in tickets) {
          let tempTicket = tickets[i];
          let categoryId = tempTicket.category_id;
          let category = tempTicket.category;

          if (categoryId && !categories.some(data => data.id === categoryId)) {
            categories.push({ id: categoryId, title: category });
          }

          let contactId = tempTicket.contact_id;
          let contact = tempTicket.contact;
          if (contactId && !contacts.some(data => data.id === contactId)) {
            contacts.push({ id: contactId, title: contact });
          }

          let complaintTypeId = tempTicket.complaint_type_id;
          let complaintType = tempTicket.complaint_type;
          if (contactId && !complaintTypes.some(data => data.id === complaintTypeId)) {
            complaintTypes.push({ id: complaintTypeId, title: complaintType });
          }

          let status = tempTicket.last_status;
          let statusIndex = status - 1;
          let statusText = statusesAll[statusIndex];
          if (statusText) {
            tickets[i]['status_text'] = statusText;
            if (!statuses.some(data => data.id === status)) {
              statuses.push({ id: status, title: statusText });
            }
          }

          let priority = tempTicket.priority;
          let priorityIndex = priority - 1;
          let priorityText = prioritiesAll[priorityIndex];
          if (priorityText) {
            tickets[i]['priority_text'] = priorityText;
            if (!priorities.some(data => data.id === priority)) {
              priorities.push({ id: priority, title: priorityText });
            }
          }
        }
      }
      commit('SET_TICKETS_FILTERS_ELEMENT', { elementName: 'categories', data: categories });
      commit('SET_TICKETS_FILTERS_ELEMENT', { elementName: 'contacts', data: contacts });
      commit('SET_TICKETS_FILTERS_ELEMENT', { elementName: 'complaintTypes', data: complaintTypes });
      commit('SET_TICKETS_FILTERS_ELEMENT', { elementName: 'statuses', data: statuses });
      commit('SET_TICKETS_FILTERS_ELEMENT', { elementName: 'priorities', data: priorities });
    } catch (error) {
      console.log(error);
    }
  },
  async addMessageToThread({ commit, state }, message) {
    try {
      let threads = state.TicketThreads;
      // threads.push(message); // put on end of list
      threads.unshift(message); // put on top of list
      commit('SET_TICKETS_THREADS', threads);
    } catch (error) {
      console.log(error);
    }
  },
  async addFileToList({ commit, state }, file) {
    try {
      let files = state.ticketFiles;
      files.push(file);
      commit('SET_TICKETS_FILES', files);
    } catch (error) {
      console.log(error);
    }
  },
  async removeFileFromList({ commit, state }, file) {
    try {
      let files = state.ticketFiles;
      files.splice(files.indexOf(file), 1);
      commit('SET_TICKETS_FILES', files);
    } catch (error) {
      console.log(error);
    }
  },
  async clearFileList({ commit, state }, file) {
    try {
      commit('SET_TICKETS_FILES', []);
    } catch (error) {
      console.log(error);
    }
  },
  async clearTicketInfo({ commit, state }) {
    try {
      commit('SET_TICKET_INFO', {});
    } catch (error) {
      console.log(error);
    }
  },
  async setTicketsThread({ commit }, params) {
    // console.log('params', params);
    try {
      commit('SET_TICKETS_THREADS', params);
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketsData({ commit, state }, locationId) {
    try {
      commit(
        'SET_TICKETS_ELEMENTS_DATA',
        await ApiFunctionCalls.getTicketsData(locationId)
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketInfo({ commit, state }, { locationId, ticketId, router }) {
    try {
      let ticketInfo = await ApiFunctionCalls.getTicketInfo(locationId, ticketId);
      commit(
        'SET_TICKET_INFO',
        ticketInfo
      );

      if (ticketInfo.comm.length) {
        commit(
          'SET_TICKETS_THREADS',
          ticketInfo.comm
        );
      }

      if (ticketInfo.files_relations.length) {
        let ticketFiles = [];
        for (let i in ticketInfo.files_relations) {
          ticketFiles.push({
            file_id: ticketInfo.files_relations[i]['file_id'],
            name: ticketInfo.files_relations[i]['name'],
            url: ticketInfo.files_relations[i]['file_url'],
            file_type: ticketInfo.files_relations[i]['file_type']
          });
        }
        commit(
          'SET_TICKETS_FILES',
          ticketFiles
        );
      }
    } catch (error) {
      console.log(error);
      router.push('/tickets');
    }
  },
  async saveTicket({ commit, state }, newTicket) {
    try {
      let saveTicketNew = await ApiFunctionCalls.saveTicketNew(newTicket);
      commit(
        'SET_SAVE_TICKET_RESULT',
        saveTicketNew
      );
      if (saveTicketNew.ticket_id) {
        let postData = {
          ticket_id: saveTicketNew.ticket_id
        };
        if (saveTicketNew.task_ids) {
          postData.task_ids = saveTicketNew.task_ids;
        }
        if (saveTicketNew.comm_ids) {
          postData.comm_ids = saveTicketNew.comm_ids;
        }
        if (saveTicketNew.file_relation_ids) {
          postData.file_relation_ids = saveTicketNew.file_relation_ids;
        }
        ApiFunctionCalls.sendTicketEmailsAfterSaving(postData);
      }
    } catch (error) {
      console.log(error);
    }
  }
};

const mutations = {
  SET_TICKETS(state, data) {
    state.tickets = data;
  },
  SET_TICKETS_FILTERS(state, data) {
    state.ticketsFilters = data;
  },
  SET_TICKETS_FILTERS_ELEMENT(state, { elementName, data }) {
    state.ticketsFilters[elementName] = data;
  },
  SET_TICKETS_THREADS(state, data) {
    state.TicketThreads = data;
  },
  SET_TICKETS_FILES(state, data) {
    state.ticketFiles = data;
  },
  SET_TICKET_INFO(state, data) {
    state.ticketInfo = data;
  },
  SET_TICKETS_ELEMENTS_DATA(state, data) {
    state.ticketsElementsData = data;
  },
  SET_SAVE_TICKET_RESULT(state, data) {
    state.saveTicketResult = data;
  }
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/tickets_v2.js